import { render, staticRenderFns } from "./PatientOverviewPA.vue?vue&type=template&id=7cda7d14&"
import script from "./PatientOverviewPA.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports